module.exports = __webpack_public_path__ + "img/instagram-logo-32.d8eecee1.svg";